import React, { memo } from 'react';
import ProjFn from '@/utils/fn';
import classnames from 'classnames';

interface HeadBtnProps {
  agreementType: number;
  clause?: boolean;
  setClause?: (val: boolean) => void;
}

function LoginFooter(props: HeadBtnProps) {
  const { agreementType, clause } = props;
  function openWeb(url: string) {
    ProjFn.openExternalBrower(url);
  }

  const getCheckState = (val: boolean) => {
    props?.setClause && props?.setClause(val);
  };

  const handleCheckboxChange = (e: any) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    const isChecked = e.target.checked;
    getCheckState(isChecked);
  };

  const footerBtn =
    agreementType === 1 ? (
      <span className="checkbox_text">登录即同意</span>
    ) : agreementType === 2 ? (
      <span className="checkbox_text">
        <input
          type="checkbox"
          className="login-clauseCheckbox login-clauseCheckboxTwo"
          checked={clause}
          onChange={handleCheckboxChange}
        />
        已仔细阅读并同意
      </span>
    ) : (
      <span className="checkbox_text">请勾选并同意</span>
    );

  return (
    <div className={classnames('loginClauseFooterBox', `${'loginClauseFooterTypeBox' + agreementType}`)}>
      {footerBtn}
      <span className="checkbox_yellow">
        <span onClick={e => openWeb('https://land.996box.com/user-agreement.html')}>《用户注册协议》</span>
        <span onClick={e => openWeb('https://land.996box.com/Privacy-policy.html')}>《隐私条款》</span>
        <span onClick={e => openWeb('https://land.996box.com/agreement/appPrivacyGuide.html')}>
          《儿童隐私保护协议》
        </span>
      </span>
    </div>
  );
}
export default memo(LoginFooter);
